import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { object, string } from 'prop-types';
import React, { memo } from 'react';

const SectionHeader = ({ title, style = {}, ...rest }) => (
  <Box
    style={style}
    {...rest}
    sx={[
      {
        display: 'flex',
        alignItems: 'center',
      },
      ...(Array.isArray(rest.sx) ? rest.sx : [rest.sx]),
    ]}
  >
    <Typography
      variant="overline"
      sx={{
        color: 'text.secondary',
        lineHeight: 1,
        letterSpacing: '0.5px',
        fontWeight: 600,
      }}
    >
      {title}
    </Typography>
  </Box>
);

SectionHeader.propTypes = {
  title: string.isRequired,
  style: object,
};

export default memo(SectionHeader);
